<template>
  <div>
    <Header></Header>
    <Nav></Nav>
    <div class="personal">
      <div class="person">
        <div class="per-title">
          采购统计分析
          <!-- <span v-if="level != 0">（{{department_name}}）</span> -->
          <template v-if="level != 0">
            <el-select v-model="id"
                      @change="framewww"
                      placeholder="请选择活动">
              <el-option v-for="item in frame_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
              </el-option>
            </el-select>
          </template>
        </div>
        <div class="per-center">
          <div class="per-order"
               v-show="list.order_price_num == null">
            <h2>0</h2>
            <p>订单金额</p>
          </div>
          <div class="per-order"
               v-show="list.order_price_num <= 9999 && list.order_price_num > 0">
            <h2>{{list.order_price_num}}</h2>
            <p>订单金额</p>
          </div>
          <div class="per-order"
               v-show="list.order_price_num > 9999">
            <h2>{{list.order_price_num }}</h2>
            <!-- <h2>{{list.order_price_num / 10000}}</h2> -->
            <p>订单金额</p>
          </div>
          <div class="per-order">
            <h2>{{list.order_detail_num}}</h2>
            <p>订单数量（单）</p>
            <!-- @click="allorder" -->
          </div>
        </div>
        <div class="trend-fot">
          <div class="trend">
            <div class="trend-title">
              <div class="trend-txt">采购趋势</div>
              <div class="trend-data">
                <span :class="{active:isActive== 1}"
                      @click="unjudge(1)">月</span>
                <span :class="{active:isActive== 2}"
                      @click="unjudge(2)">周</span>
                <span :class="{active:isActive== 3}"
                      @click="unjudge(3)">日</span>
              </div>
            </div>
            <div id="myChart"
                 v-bind:type="isActive"></div>
          </div>
          <div>
            <div class="special">
              <div class="special-title">商品排行</div>
              <div v-if="top_list && top_list.length">
                <div class="special-rank"
                     target="_blank"
                     v-for="(item,index) in top_list"
                     :key="index">
                  <img src='../../../assets/images/top1.svg'
                       alt
                       v-if="index == 0" />
                  <img src='../../../assets/images/top2.svg'
                       alt
                       v-if="index == 1" />
                  <img src='../../../assets/images/top3.svg'
                       alt
                       v-if="index == 2" />
                  <img src='../../../assets/images/top4.svg'
                       alt
                       v-if="index == 3" />
                  <!-- @click="goodsDetails(item.id)" -->
                  <div class="rank">
                    <img class="special-r-item-goods"
                         v-lazy="item.cover_pic" />
                    <div class="special-r-item-box">
                      <div>{{item.name}}</div>
                      <div>￥{{item.price}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 暂无商品时暂时 -->
              <template v-else>
                <div class="zanwugoods"
                     v-if="datatype">
                  <img src="../../../assets/images/ttshop_zanwu.png"
                       alt="">
                  <p>暂无商品</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/purchase/header/header'
import Nav from '@/components/purchase/nav/nav'
import Footer from '@/components/purchase/footer/footer'
import './personal.css'

export default {
  components: {
    Header,
    Nav,
    Footer
  },
  data() {
    return {
      isActive: 1,
      datatype: false,
      route_url: this.$store.state.route_url,
      access_token: this.$store.state.qycg_user.access_token,
      list: [],
      top_list: [], //	排行榜
      mapping_list: [], //统计数据列表
      ordinate_list: [], //横坐标对应数据
      abscissa_list: [], //横坐标
      frame_list: [], //部门列表
      id: '', //部门id
      level: this.$store.state.qycg_user.is_admin, //权限
      department_name: '', //部门名称
      department_id: this.$store.state.qycg_user.department_id
    }
  },
  created() {
    this.getOrderList()
    // if(this.department_id != 0){
    // 	this.departmentName();
    // }
    this.departmentapi()
  },
  mounted() {},
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  watch: {
    //监听的对象
    xAxis(newVal, oldVal) {
      //重绘
      this.initChart(newVal, this.abscissa_list)
    },
    series(newVal, oldVal) {
      this.initChart(newVal, this.ordinate_list)
    }
  },
  methods: {
    framewww(id) {
      this.id = id
      this.getOrderList()
    },

    // 获取部门名称
    departmentName() {
      let dep_id = this.department_id
      this.$api
        .departmentName({
          shop_type: 'qycg',
          access_token: this.$store.state.qycg_user.access_token,
          dep_id: dep_id
        })
        .then(res => {
          // console.log(res)
          this.department_name = res.data.name
        })
        .catch(err => {
          // console.log(err);
        })
    },

    // 获取部门列表
    departmentapi() {
      let keyword = this.searchFrame
      this.$api
        .department({
          shop_type: 'qycg',
          access_token: this.$store.state.qycg_user.access_token,
          keyword: keyword
        })
        .then(res => {
          // console.log(res)
          this.frame_list = res.data
        })
        .catch(err => {
          // console.log(err);
        })
    },

    // 获取统计数据
    getOrderList() {
      let access_token = this.access_token
      let type = this.isActive
      this.datatype = false
      if (this.level == 1) {
        this.id = this.id
      } else {
        this.id = this.department_id
      }
      let id = this.id
      this.abscissa_list = []
      this.ordinate_list = []
      this.$api
        .statisticsPage({
          access_token: access_token,
          type: type,
          act_id: id
        })
        .then(res => {
          this.list = res.data
          // console.log(this.list)
          this.top_list = res.data.top_list
          this.mapping_list = res.data.mapping_list
          for (let index in this.mapping_list) {
            this.abscissa_list.push(this.mapping_list[index].date)
          }
          // console.log(this.top_list)
          // console.log(this.abscissa_list)
          for (let index in this.mapping_list) {
            this.ordinate_list.push(this.mapping_list[index].order_count)
          }
          // console.log(this.ordinate_list)
          // console.log(this.mapping_list)
          this.drawLine(this.ordinate_list, this.abscissa_list)
          document.querySelector('body')
          // .setAttribute('style', 'background-color:#F2F2F2')
          this.datatype = true
        })
        .catch(err => {
          // console.log(err);
        })
    },

    //全部订单列表跳转
    // allorder(){
    // 	let id = this.id;
    // 	// console.log(id)
    // 	let url = this.$router.resolve({
    // 		path: this.common.qycgrouter(this) + '/allorderlist',
    // 		query: {
    // 			id: id
    // 		}
    // 	})
    // 	window.open(url.href);
    // },

    // 排行榜商品跳转详情
    goodsDetails(id) {
      let url = this.$router.resolve({
        path: this.common.qycgrouter(this) + '/qycgdetails',
        query: {
          id: id
        }
      })
      window.open(url.href)
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例(注意使用this.$echarts)
      var myChart = this.$echarts.init(document.getElementById('myChart'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: this.abscissa_list
        },
        yAxis: {
          type: 'value'
        },
        // 保存为图片
        // toolbox: {
        // 	feature: {
        // 		saveAsImage: {}
        // 	}
        // },
        series: [
          {
            name: '采购量',
            type: 'line',
            abel: {
              normal: {
                show: true
              }
            },
            data: this.ordinate_list
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },
    unjudge(i) {
      this.isActive = i
      this.getOrderList()
    }
  }
}
</script>

<style lang="scss" scoped>
// 暂无商品
.zanwugoods {
  width: 100%;
  padding: 60px 0;
  box-sizing: border-box;

  img {
    display: block;
    width: 93px;
    height: 80px;
    margin: 0 auto 20px;
  }

  p {
    font-size: 16px;
    color: #333;
    text-align: center;
  }
}

.personal {
  width: 100%;
  background-color: #f2f2f2;
  padding-top: 20px;

  .person {
    width: 1080px;
    height: 763px;
    margin: 0 auto;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);

    .per-title {
      font-size: 16px;
      padding-top: 40px;
      margin-left: 40px;
      margin-bottom: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;

      span {
        font-size: 16px;
      }
    }

    .per-center {
      width: 1000px;
      height: 132px;
      margin: 0 auto;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: center;

      .per-order {
        width: 154px;
        height: 40px;

        text-align: center;

        h2 {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          letter-spacing: 1px;
          margin-top: -10px;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
          // cursor: pointer;
        }
      }

      .per-order:first-child {
        margin-right: 147px;
      }
    }

    .trend-fot {
      display: flex;
      justify-content: space-between;

      .trend {
        width: 600px;

        .trend-title {
          margin-top: 60px;
          width: 600px;
          display: flex;
          align-items: center;

          .trend-txt {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 18px;
            margin-right: 78px;
            margin-left: 40px;
          }

          .trend-data {
            display: flex;

            span {
              display: block;
              width: 62px;
              height: 28px;
              margin-right: 12px;
              text-align: center;
              line-height: 28px;
              border-radius: 16px;
              border: 1px solid #f0f0f0;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              cursor: pointer;
            }

            .active {
              background: #ff0e25;
              color: #ffffff;
            }
          }
        }

        #myChart {
          width: 600px;
          height: 400px;
        }
      }

      .special {
        width: 450px;
        height: 420px;
        overflow: hidden;
        margin-top: 40px;
        margin-right: 20px;
        background-color: #fff;
        padding: 0 20px 20px 20px;
        box-sizing: border-box;

        .special-title {
          line-height: 58px;
          height: 58px;
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .special-rank {
          margin-bottom: 18px;
          display: flex;
          align-items: center;

          img {
            width: 27px;
            height: 39px;
          }

          .rank {
            display: flex;
            // cursor: pointer;

            :first-child {
              width: 27px;
              height: 39px;
            }

            .special-r-item-goods {
              width: 69px;
              height: 69px;
              margin-left: 14px;
            }

            .special-r-item-box {
              margin-left: 16px;

              :first-child {
                width: 100%;
                height: 34px;
                margin-bottom: 12px;
                overflow: hidden;
                line-height: 18px;

                // &:hover {
                // 	color: #ff0e25;
                // }
              }

              :last-child {
                color: #ff0e25;
                font-size: 16px;
              }
            }
          }
        }

        a:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
